<template>
  <div
    v-show="isShow"
    class="info-portability bg-green-light flex p-3"
    :class="{
      'bg-red-light': messageType == 'error',
      'bg-green-light': messageType == 'info',
      'bg-yellow-light': messageType == 'alert',
    }"
  >
    <span v-show="showIcon" class="mr-3 flex items-center">
      <svg class="info-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.89331 19.8887C15.3055 19.8887 19.7866 15.3979 19.7866 9.99536C19.7866 4.58313 15.2958 0.102051 9.8836 0.102051C4.48108 0.102051 0 4.58313 0 9.99536C0 15.3979 4.49078 19.8887 9.89331 19.8887ZM9.89331 18.2398C5.31523 18.2398 1.65858 14.5735 1.65858 9.99536C1.65858 5.41728 5.30552 1.75093 9.8836 1.75093C14.4617 1.75093 18.1377 5.41728 18.1377 9.99536C18.1377 14.5735 14.4714 18.2398 9.89331 18.2398Z"
          fill="#292E56"
        />
        <path
          d="M8.19584 15.4269H12.1435C12.5411 15.4269 12.8515 15.136 12.8515 14.7383C12.8515 14.36 12.5411 14.0593 12.1435 14.0593H10.9407V9.12241C10.9407 8.59861 10.6789 8.24944 10.1842 8.24944H8.36071C7.96304 8.24944 7.65267 8.5501 7.65267 8.92841C7.65267 9.32608 7.96304 9.61703 8.36071 9.61703H9.39856V14.0593H8.19584C7.79817 14.0593 7.48779 14.36 7.48779 14.7383C7.48779 15.136 7.79817 15.4269 8.19584 15.4269ZM9.80595 6.63939C10.514 6.63939 11.0668 6.07679 11.0668 5.36875C11.0668 4.6607 10.514 4.09814 9.80595 4.09814C9.10761 4.09814 8.54501 4.6607 8.54501 5.36875C8.54501 6.07679 9.10761 6.63939 9.80595 6.63939Z"
          fill="#292E56"
        />
      </svg>
    </span>
    <div>
      <p class="text-sm text-green-dark">
        {{ infoText }}
      </p>
      <p class="text-sm text-green-dark">
        {{ infoTextExtra }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    infoText: {
      type: String,
      required: true,
    },
    infoTextExtra: {
      type: String,
      default: '',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    messageType: {
      type: String,
      default: 'info',
    },
  },
}
</script>

<style>
@media screen and (max-width: 450px) {
  .info-icon {
    display: none;
  }
}
</style>
